export const STALE_TIME = Infinity

export const MAX_SIZE = 50

export const DEFAULT_LIST_PARAMS = {
  page: 1,
  perPage: 8,
  order: 'desc',
  orderBy: 'createdAt'
}
